var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_116_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_116_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3.77225e-06C8.82439 3.77225e-06 6.69764 0.645141 4.88872 1.85383C3.07979 3.06253 1.66989 4.78046 0.837332 6.79049C0.0047679 8.80045 -0.213072 11.0122 0.211367 13.146C0.635805 15.2797 1.68345 17.2398 3.22183 18.7782C4.76021 20.3165 6.72022 21.3642 8.85403 21.7886C10.9878 22.213 13.1995 21.9952 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1461 17.1112C21.3549 15.3024 22 13.1756 22 11C22.0012 9.55515 21.7175 8.12421 21.1651 6.78906C20.6127 5.45393 19.8025 4.24085 18.7808 3.21917C17.7591 2.19749 16.5461 1.38727 15.2109 0.834897C13.8758 0.282522 12.4449 -0.00119329 11 3.77225e-06ZM11 19.4118C9.33625 19.4118 7.70996 18.9184 6.32668 17.9941C4.9434 17.0699 3.86521 15.756 3.22855 14.2191C2.59188 12.682 2.4253 10.9907 2.74987 9.35889C3.07444 7.72723 3.87558 6.22839 5.05197 5.05197C6.22839 3.87558 7.72724 3.07444 9.35889 2.74987C10.9906 2.4253 12.682 2.59188 14.2191 3.22855C15.756 3.86521 17.0699 4.9434 17.9941 6.32668C18.9184 7.70997 19.4118 9.33625 19.4118 11C19.414 12.1053 19.1979 13.2001 18.776 14.2216C18.3541 15.2433 17.7345 16.1714 16.9529 16.9529C16.1714 17.7345 15.2433 18.3541 14.2216 18.776C13.2001 19.1979 12.1053 19.414 11 19.4118ZM14.8824 10.0294H12.2942V7.44117C12.2942 7.09797 12.1577 6.76881 11.9151 6.5261C11.6724 6.28339 11.3432 6.14706 11 6.14706C10.6568 6.14706 10.3276 6.28339 10.0849 6.5261C9.84225 6.76881 9.70585 7.09797 9.70585 7.44117V10.0294H7.11764C6.77444 10.0294 6.44529 10.1657 6.20257 10.4085C5.95986 10.6512 5.82353 10.9803 5.82353 11.3235C5.82353 11.6667 5.95986 11.9959 6.20257 12.2386C6.44529 12.4813 6.77444 12.6176 7.11764 12.6176H9.70585V15.2059C9.70585 15.5491 9.84225 15.8782 10.0849 16.121C10.3276 16.3637 10.6568 16.5 11 16.5C11.3432 16.5 11.6724 16.3637 11.9151 16.121C12.1577 15.8782 12.2942 15.5491 12.2942 15.2059V12.6176H14.8824C15.2256 12.6176 15.5547 12.4813 15.7974 12.2386C16.0401 11.9959 16.1765 11.6667 16.1765 11.3235C16.1765 10.9803 16.0401 10.6512 15.7974 10.4085C15.5547 10.1657 15.2256 10.0294 14.8824 10.0294Z",
    fill: "#5B7E9E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.87dda12c46bd683d2d358f404bd1b76c.svg";
export { ForwardRef as ReactComponent };